angular.module("app").constant("casinoVolatility", [{
    key: "Select",
    value: ""
},{
    key: "HIGH",
    value: "2"
},{
    key: "MEDIUM",
    value: "1"
}, {
    key: "LOW",
    value: "0"
}]);